<mat-card appearance="outlined" class="card" xmlns="http://www.w3.org/1999/html">
  <div class="flex-row">
    <div class="fxflex-1-0" style="flex-basis: 15%">
      <button
        matButton="elevated"
        color="primary"
        (click)="createForm()"
        class="app-panel-button"
        i18n
        [disabled]="editMode === true"
      >
        Create New Template
      </button>
      <button
        matButton="elevated"
        color="primary"
        (click)="editForm()"
        class="app-panel-button"
        i18n
        [disabled]="editMode === false"
      >
        Edit Existing Template
      </button>
      @if (editMode) {
        <div class="app-form-loader-div">
          <mat-slide-toggle
            [checked]="showOnlyActive"
            (change)="onShowOnlyActiveChange($event)"
          >
            @if (showOnlyActive) {
              <span i18n>Active forms</span>
            }
            @if (!showOnlyActive) {
              <span i18n>All forms</span>
            }
          </mat-slide-toggle>
          <app-form-loader [showOnlyActive]="showOnlyActive"
            [searchable]="true"
            appearance="outline"
            (formSelected)="onFormSelected($event)"
           />
        </div>
      }
      @if (!editMode) {
        <button
          matButton="elevated"
          (click)="clearRefresh()"
          class="app-panel-button"
          i18n
          [disabled]="editMode === null"
        >
          Clear and Refresh
        </button>
      }

      <button
        matButton="elevated"
        color="primary"
        (click)="saveToJSON()"
        class="app-panel-button"
        i18n
        [disabled]="form.invalid || form.pristine"
      >
        Save to local Json File
      </button>
      <button
        matButton="elevated"
        color="primary"
        class="app-panel-button"
        [disabled]="editMode === true"
        (click)="jsonInput()"
        i18n
      >
        Load template from JSON file
      </button>
      <input
        id="jsonInput"
        hidden
        type="file"
        (change)="jsonSelected($event)"
        name="file"
        accept=".txt"
      />
      <button
        matButton="elevated"
        color="accent"
        type="submit"
        (click)="saveForm()"
        class="app-panel-button"
        i18n
        [disabled]="form.invalid || form.pristine || base64textString === ''"
      >
        Save Form Template
      </button>
    </div>
    @if (editMode !== null) {
      <div class="fxflex-1-0" style="flex-basis: 65%">
        <form [formGroup]="form">
          <mat-card-title>
            <mat-form-field style="padding-right: 6em; width: 20em">
              <mat-label i18n>Form name</mat-label>
              <input matInput formControlName="title" />
            </mat-form-field>
            <button matButton="elevated" color="accent" (click)="openInput()">
              <mat-icon>document_scanner</mat-icon>
              <span i18n>Select template for pdf</span>
            </button>
            <input
              id="fileInput"
              hidden
              type="file"
              (change)="fileChange($event)"
              name="file"
              accept=".docx"
            />
          </mat-card-title>
          <mat-card-content>
            <app-form-edit [editForm]="form" />
          </mat-card-content>
        </form>
      </div>
    } @else {
      <div class="fxflex-1-0" style="flex-basis: 65%">
        <h2 i18n>
          Create new form or select existing one, edit it and save as a new
          template
        </h2>
      </div>
    }
    @if (editMode !== null) {
      <div style="flex-basis: 15%" class="flex-col start-start fxflex-1-0">
        <form [formGroup]="form">
          <div>
            <mat-form-field>
              <mat-label i18n>Select Form Assignment</mat-label>
              <mat-select formControlName="orderRelated">
                <mat-option [value]="true" i18n>Order</mat-option>
                <mat-option [value]="false" i18n>User</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label i18n="@@formtype">Select Form Type</mat-label>
              <mat-select
                formControlName="formType"
                [compareWith]="compareFormTypes"
              >
                <mat-option [value]="null">-</mat-option>
                @for (formtype of formtypes; track formtype) {
                  <mat-option [value]="formtype">{{
                    formtype.name
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
         <div>
            <mat-slide-toggle
              class="app-section-headline"
              formControlName="isSurvey"
              i18n
            >Form used as a survey
            </mat-slide-toggle>
           @if (form.controls.isSurvey.value) {
             <div i18n>This form will be used as a survey</div>
           }
         </div>
          <br />
          @if(!form.controls.isSurvey.value){
            @if (form.controls.orderRelated.value) {
              <mat-slide-toggle
                class="app-section-headline"
                formControlName="signaturePerUser"
                i18n
              >Collect signatures from team?
              </mat-slide-toggle>
              @if (!form.controls.signaturePerUser.value) {
                <div i18n>No signatures from team</div>
              }
              @if (form.controls.signaturePerUser.value) {
                <div i18n>Signature window for each technician</div>
              }
              <br />
              <mat-slide-toggle
                class="app-section-headline"
                formControlName="attachmentOnly"
                i18n
              >To be used only as attachment?
              </mat-slide-toggle>
              @if (!form.controls.attachmentOnly.value) {
                <div i18n>This form can be used as standalone document</div>
              }
              @if (form.controls.attachmentOnly.value) {
                <div i18n>This form can be used only as attachment</div>
              }
              <br />
              @if (!form.controls.attachmentOnly.value) {
                <mat-slide-toggle
                  class="app-section-headline"
                  formControlName="multiFormAllowed"
                  i18n
                >
                  Multiple forms allowed?
                </mat-slide-toggle>
                @if (!form.controls.multiFormAllowed.value) {
                  <div i18n>Only one form per order</div>
                }
                @if (form.controls.multiFormAllowed.value) {
                  <div i18n>Multiple form allowed per order</div>
                }
                <br />
                <div>{{ form.controls.additionalServicemanAllowed.value }}</div>
                <mat-slide-toggle
                  class="app-section-headline"
                  formControlName="additionalServicemanAllowed"
                  i18n
                >Additional serviceman
                </mat-slide-toggle>
                @if (form.controls.additionalServicemanAllowed.value) {
                  <div i18n>is allowed to fill out this form</div>
                }
                @if (!form.controls.additionalServicemanAllowed.value) {
                  <div i18n>may not fill out this form</div>
                }
                <br />
                <mat-slide-toggle
                  class="app-section-headline"
                  formControlName="sendByEmail"
                  i18n
                >
                  Send by e-mail
                </mat-slide-toggle>
                @if (form.controls.sendByEmail.value) {
                  <div i18n>
                    send by email to assigned addresses (customer/installation)
                  </div>
                }
                @if (!form.controls.sendByEmail.value) {
                  <div i18n>
                    this form will not be send by e-mail to customer or
                    installation
                  </div>
                }
                <br />
              }
            }

          }
        </form>
      </div>
    } @else {
      <div class="fxflex-1-0" style="flex-basis: 15%"></div>
    }
  </div>
</mat-card>
